import { ReactNode, useState } from 'react';
import UserTransactionsTable from './UserTransactionsTable';
import UserBeneficiariesTable from './UserBeneficiariesTable';
import UserApprovalsTable from './UserApprovalsTable';
import { useTransactions } from '../../../customhooks/useTransactions';
import { TransactionStatus } from '../../../interfaces/Transactions';
import useBeneficiaries from '../../../customhooks/beneficiaries/useBeneficiaries';
import { useApprovals } from '../../../customhooks/useApprovals';
import AddBeneficiaryDrawer from './AddBeneficiaryDrawer';
import { FilterParams } from '../../../interfaces/Filter';

const UserPaymentTable = ({ activeView }: { activeView: string }) => {
    const [showAddBeneficiary, setShowAddBeneficiary] = useState(false);
    const [beneficiaryId, setBeneficiaryId] = useState<number | null>(null);

    const [transactionFilterOptions, setTransactionFilterOptions] =
        useState<FilterParams>({
            page: 1,
            size: 10
        });

    const [beneficiariesFilterOptions, setBeneficiariesFilterOptions] =
        useState<FilterParams>({
            page: 1,
            size: 10
        });

    const [approvalsFilterOptions, setApprovalsFilterOptions] =
        useState<FilterParams>({
            page: 1,
            size: 10,
            status: String(TransactionStatus.PENDING)
        });

    const {
        isLoading: isTransactionsLoading,
        transactionsList,
        invalidateTransactionsCache: fetchTransactions,
        isFetching: isFetchingTransactions,
        transactionPaging
    } = useTransactions(transactionFilterOptions);

    const {
        beneficiaries,
        isLoading: isBeneficiariesLoading,
        invalidateBeneficiaryCache: fetchBeneficiaries,
        isBeneficiariesFetching,
        beneficiaryPaging
    } = useBeneficiaries(beneficiariesFilterOptions);

    const {
        isLoading: isApprovalsLoading,
        approvalsList,
        invalidateTransactionsCache: fetchApprovals,
        isFetching: isApprovalsFetching,
        approvalsPaging
    } = useApprovals(approvalsFilterOptions);

    const views: { [key: string]: ReactNode } = {
        transactions: (
            <UserTransactionsTable
                {...{
                    isTransactionsLoading,
                    isFetchingTransactions,
                    transactionsList,
                    transactionPaging,
                    transactionFilterOptions,
                    setTransactionFilterOptions,
                    fetchTransactions,
                    beneficiaries
                }}
            />
        ),
        beneficiaries: (
            <UserBeneficiariesTable
                {...{
                    isBeneficiariesLoading,
                    beneficiaries,
                    fetchBeneficiaries,
                    isBeneficiariesFetching,
                    paging: beneficiaryPaging,
                    setShowAddBeneficiary,
                    setBeneficiaryId,
                    beneficiaryPaging,
                    beneficiariesFilterOptions,
                    setBeneficiariesFilterOptions
                }}
            />
        ),
        approvals: (
            <UserApprovalsTable
                {...{
                    isApprovalsLoading,
                    approvalsList,
                    fetchApprovals,
                    isApprovalsFetching,
                    beneficiaries,
                    approvalsFilterOptions,
                    setApprovalsFilterOptions,
                    approvalsPaging
                }}
            />
        )
    };

    return (
        <>
            {activeView && views[activeView]}

            <AddBeneficiaryDrawer
                closeDrawer={() => setShowAddBeneficiary(false)}
                showDrawer={showAddBeneficiary}
                reRunGetBeneficiaries={fetchBeneficiaries}
                beneficiaryId={beneficiaryId ?? undefined}
                setBeneficiaryId={setBeneficiaryId ?? undefined}
            />
        </>
    );
};

export default UserPaymentTable;
